var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 140,
    viewBox: "0 0 193 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Background",
    opacity: 0.03,
    d: "M183.607 103.105C177.901 94.7275 171.272 84.7784 173.165 74.0843C176.374 63.1903 184.192 54.0499 189.952 44.5006C196.755 32.48 191.57 28.4822 180.343 24.0755C176.484 22.6763 171.391 21.904 167.624 20.2867C159.395 15.6802 160.109 7.85721 148.369 2.68733C140.953 -1.42858 133.941 -0.174725 126.251 2.18761C119.869 3.8049 112.893 4.59537 106.319 4.39548C87.4379 3.25974 68.2736 2.23304 49.3562 2.50561C40.5055 2.75093 30.7588 2.84179 22.2281 5.43127C10.4699 10.5557 1.07064 21.0499 0.0374505 34.3699C-0.940878 66.9155 17.6108 73.2484 13.3226 85.2054C9.78417 96.9717 6.55659 120.032 18.3423 127.764C28.3633 132.17 49.6214 122.548 62.0928 122.594C74.2624 121.894 77.9655 124.711 88.1236 129.999C99.5253 135.151 111.969 138.249 124.386 139.412C142.398 141.284 160.904 138.631 177.865 132.27C195.804 125.029 195.091 117.115 183.607 103.096V103.105Z",
    fill: "#080333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying glass"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M102.958 82.5879L109.295 76.2508L138.936 105.891C140.498 107.453 140.498 109.986 138.936 111.548L138.255 112.228C136.693 113.79 134.161 113.79 132.599 112.228L102.958 82.5879Z",
    fill: "#795AF7",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M102.958 82.5879L109.295 76.2508L119.036 85.9914L112.699 92.3285L102.958 82.5879Z",
    fill: "#E7F0FE",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    opacity: 0.18,
    d: "M109.831 76.545L103.229 83.1465L106.429 86.3461L113.031 79.7447L109.831 76.545Z",
    fill: "#080333"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M90.4601 84.6904C76.7385 84.6904 65.6149 73.5668 65.6149 59.8452C65.6149 46.1236 76.7385 35 90.4601 35C104.182 35 115.305 46.1236 115.305 59.8452C115.305 73.5668 104.182 84.6904 90.4601 84.6904Z",
    fill: "#E8E8FD",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M90.2142 77.8892C79.9499 77.8892 71.629 69.8884 71.629 60.0188C71.629 50.1493 79.9499 42.1484 90.2142 42.1484C100.479 42.1484 108.799 50.1493 108.799 60.0188C108.799 69.8884 100.479 77.8892 90.2142 77.8892Z",
    fill: "#E7F0FE",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    opacity: 0.18,
    d: "M90.2142 41.1151C77.3996 41.1151 66.9303 48.4946 65.9785 57.8741C65.9445 57.3223 65.9105 56.7936 65.9105 56.2189C65.9105 44.4945 76.7877 35 90.2142 35C103.641 35 114.518 44.5174 114.518 56.2189C114.518 56.7706 114.518 57.3223 114.45 57.8741C113.498 48.4946 102.995 41.1151 90.2142 41.1151Z",
    fill: "#000917"
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    opacity: 0.18,
    d: "M90.2143 47.4C80.4148 47.4 72.4089 52.0122 71.6811 57.8744C71.6551 57.5296 71.6291 57.1991 71.6291 56.8399C71.6291 49.5122 79.9469 43.5781 90.2143 43.5781C100.482 43.5781 108.799 49.5265 108.799 56.8399C108.799 57.1847 108.799 57.5296 108.747 57.8744C108.02 52.0122 99.9877 47.4 90.2143 47.4Z",
    fill: "#000917"
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M77.3476 59.3042C77.3476 52.9877 82.4681 47.8672 88.7846 47.8672",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.7s",
    repeatCount: "indefinite",
    path: "M-10,-5 m -10, 0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.55eff4ac9d8d83ab006fd6d275438fdd.svg";
export { ForwardRef as ReactComponent };